"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M10.3563 9.7063v-.7625a5.6275 5.6275 0 0 0-.8-.0687c-2.5943-.0055-4.891 1.6756-5.67 4.1502-.779 2.4745.1404 5.1682 2.27 6.6498a5.925 5.925 0 0 1-1.131-6.3456 5.925 5.925 0 0 1 5.331-3.6232z",
    fill: "#25F4EE"
  }), _react.default.createElement("path", {
    d: "M10.5 18.3438c1.4505-.002 2.6428-1.1447 2.7063-2.5938V2.8187h2.3624A4.4323 4.4323 0 0 1 15.5 2h-3.2313v12.9188c-.0537 1.4564-1.2487 2.6101-2.7062 2.6125a2.7523 2.7523 0 0 1-1.25-.3125 2.713 2.713 0 0 0 2.1875 1.125zm9.4812-11.1376v-.7188a4.4124 4.4124 0 0 1-2.4437-.7375 4.4812 4.4812 0 0 0 2.4437 1.4563z",
    fill: "#25F4EE"
  }), _react.default.createElement("path", {
    d: "M17.5375 5.75a4.45 4.45 0 0 1-1.1063-2.9375h-.8625A4.4753 4.4753 0 0 0 17.5375 5.75zm-7.9812 6.3562c-1.2448.0064-2.3254.8592-2.621 2.0683-.2956 1.2091.2696 2.4642 1.371 3.0442A2.7061 2.7061 0 0 1 10.5 12.925c.2713.0034.5407.0455.8.125V9.7625a5.675 5.675 0 0 0-.8-.0625h-.1437v2.5a2.7829 2.7829 0 0 0-.8-.0938z",
    fill: "#FE2C55"
  }), _react.default.createElement("path", {
    d: "M19.9813 7.2063v2.5A7.6688 7.6688 0 0 1 15.5 8.25v6.5688c-.0069 3.2777-2.666 5.9312-5.9437 5.9312a5.8806 5.8806 0 0 1-3.4-1.075c1.66 1.7855 4.2437 2.3733 6.5129 1.4816 2.2691-.8916 3.7615-3.081 3.7621-5.5191v-6.55a7.6811 7.6811 0 0 0 4.4875 1.4375V7.3063a4.5806 4.5806 0 0 1-.9375-.1z",
    fill: "#FE2C55"
  }), _react.default.createElement("path", {
    d: "M15.5001 14.8187V8.25a7.6686 7.6686 0 0 0 4.4875 1.4375v-2.5a4.4808 4.4808 0 0 1-2.45-1.4375 4.4746 4.4746 0 0 1-1.9688-2.9375h-2.3625V15.75A2.7125 2.7125 0 0 1 8.3 17.2312c-1.1013-.58-1.6666-1.8351-1.371-3.0442.2957-1.2092 1.3763-2.0619 2.621-2.0683.2714.0024.5409.0446.8001.125v-2.5a5.9251 5.9251 0 0 0-4.2 10A5.8812 5.8812 0 0 0 9.5563 20.75c3.2778 0 5.9369-2.6535 5.9438-5.9313z"
  })];
};

exports.default = _default;